"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var CookieConsentStore_1 = __importDefault(require("./CookieConsentStore"));
var CookieConsentNotification_1 = __importDefault(require("./CookieConsentNotification"));
var AutoAcceptRequestWatcher_1 = __importDefault(require("./AutoAcceptRequestWatcher"));
var helpers_1 = require("./helpers");
var FHCookieGuard = (function () {
    function FHCookieGuard(notificationElementSelector, options) {
        if (notificationElementSelector === void 0) { notificationElementSelector = '.js-cookie-alert'; }
        if (options === void 0) { options = {}; }
        this.cookieConsentNotificationElement = document.querySelector(notificationElementSelector);
        var defaultOptions = {
            selectors: {
                accept: '.js-cookie-alert-accept',
                refuse: '.js-cookie-alert-refuse',
                cookieGuard: '.js-cookie-guarded',
                parentContainer: 'body'
            },
            cookieName: 'cookies-accepted',
            cookieAttributes: {
                expires: 90,
                domain: window.location.hostname,
                path: '/',
            },
            autoAcceptCookieConsentAfterRequestCount: null,
            activeClass: 'cookie-alert-is-active',
            excludedPageUrls: [],
            callbacks: {
                onOpenCookieAlert: null,
                onCloseCookieAlert: null,
            }
        };
        this.options = lodash_1.merge(defaultOptions, options, this.cookieConsentNotificationElement ? this.cookieConsentNotificationElement.dataset : {});
        this.cookieConsentStore = new CookieConsentStore_1.default(this.options.cookieName, this.options.cookieAttributes);
        this.init();
    }
    FHCookieGuard.prototype.init = function () {
        this.initCookieConsentNotificationIfNeeded();
        this.initAutoAcceptCookieConsentIfNeeded();
    };
    FHCookieGuard.prototype.initCookieConsentNotificationIfNeeded = function () {
        if (!this.cookieConsentNotificationElement || this.cookieConsentStore.hasBeenSet() || helpers_1.isCurrentPageExcluded(this.options.excludedPageUrls)) {
            return;
        }
        this.cookieConsentNotification = new CookieConsentNotification_1.default(this.cookieConsentNotificationElement, this.cookieConsentStore, this.options, this.enableCookieGuardedContent);
        if (this.cookieConsentNotification) {
            this.cookieConsentNotification.show();
        }
    };
    FHCookieGuard.prototype.initAutoAcceptCookieConsentIfNeeded = function () {
        var _this = this;
        var _a = this.options, autoAcceptCookieConsentAfterRequestCount = _a.autoAcceptCookieConsentAfterRequestCount, cookieAttributes = _a.cookieAttributes;
        if (autoAcceptCookieConsentAfterRequestCount === null || this.cookieConsentStore.hasBeenSet() || helpers_1.isCurrentPageExcluded(this.options.excludedPageUrls)) {
            return;
        }
        new AutoAcceptRequestWatcher_1.default(this.cookieConsentStore, autoAcceptCookieConsentAfterRequestCount, cookieAttributes, function () {
            _this.enableCookieGuardedContent();
            if (_this.cookieConsentNotification) {
                _this.cookieConsentNotification.close();
            }
        });
    };
    FHCookieGuard.prototype.enableCookieGuardedContent = function () {
        var selectors = this.options.selectors;
        var cookieGuardedElements = document.querySelectorAll(selectors.cookieGuard);
        var parser = new DOMParser();
        if (!cookieGuardedElements.length) {
            return;
        }
        Array.prototype.forEach.call(cookieGuardedElements, function (element) {
            if (!element.dataset.content) {
                return;
            }
            var content = parser.parseFromString(element.dataset.content, 'text/html');
            var guardedScript = content.querySelector('script');
            if (!guardedScript) {
                return;
            }
            var newScriptElement = document.createElement('script');
            if (guardedScript.src) {
                newScriptElement.src = guardedScript.src;
            }
            else {
                newScriptElement.innerHTML = guardedScript.innerHTML;
            }
            var parentNode = element.parentNode;
            if (parentNode) {
                parentNode.replaceChild(newScriptElement, element);
            }
        });
    };
    return FHCookieGuard;
}());
exports.default = FHCookieGuard;
